import store from '@/store'

export default function authMiddleware({ next, router }) {
    if (!store.getters.isLoggedIn) {
        return router.push({ name: 'Login' });
    }
    next();
}
  